<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-client-portal-dialog"
      :open.sync="openDialog"
      :form-ref.sync="groupFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer un groupe</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <v-select
            class="pa-4"
            v-model="groupForm.partner"
            label="Partenaire"
            :items="partners"
            item-value="id"
            item-text="name"
            :rules="rules.partnerRules"
          ></v-select>
          <v-text-field
            class="pa-4"
            v-model="groupForm.description"
            label="Description"
            hint="Nom du groupe lisible, utilisé par l'outil de recherche. Il doit être unique."
            persistent-hint
            :rules="rules.descriptionRules"
          ></v-text-field>
          <v-select
            class="pa-4"
            v-model="groupForm.portalProfile"
            return-object
            label="Template prédéfini"
            :items="portalProfiles"
            item-value="id"
            item-text="name"
            hint=""
            persistent-hint
          ></v-select>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { onMounted, toRefs, computed } from "@vue/composition-api";
import { useGroup } from "@/composables/group";
import { usePortalProfile } from "@/composables/portal-profile";
import { usePartner } from "@/composables/partner";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { createGroup, data } = useGroup();
    const { portalProfiles, listPortalProfileV5 } = usePortalProfile();
    const { partnerData, listPartners } = usePartner();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(async () => {
      await listPartners();
      await listPortalProfileV5();
      if (portalProfiles.value.length > 0) {
        data.groupForm.portalProfile = portalProfiles.value[0];
      }
    });

    /* Méthodes */
    const saveItem = async function () {
      data.groupForm.portalProfile = data.groupForm.portalProfile.id;
      await createGroup();
      openDialog.value = false;
    };

    return {
      createGroup,
      portalProfiles,
      ...toRefs(data),
      ...toRefs(partnerData),
      saveItem,
      openDialog,
    };
  },
};
</script>
